// export const canPIP = () =>
// {
// 	return 'pictureInPictureEnabled' in document && document.pictureInPictureEnabled;
// };

// export const isInPIP = () =>
// {
// 	return Boolean(document.pictureInPictureElement);
// };

export const canPIP = () =>
{
	return 'documentPictureInPicture' in window &&
		typeof window.documentPictureInPicture.requestWindow === 'function';
};

export const isInPIP = () =>
{
	return Boolean(window?.documentPictureInPicture?.window);
};

const supportsOldSafariPIP = () =>
{
	const video = document.createElement('video');

	return (
		canPIP() && video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === 'function'
	);
};

const supportsModernPIP = () =>
{
	const video = document.createElement('video');

	return (
		canPIP() && video.requestPictureInPicture && typeof video.requestPictureInPicture === 'function'
	);
};

export const supportsPIP = () =>
{
	return supportsOldSafariPIP() || supportsModernPIP();
};

// const styleDrawEle = (ctx, video, x, y, width, height) =>
// {
// 	ctx.drawImage(video, x, y, width, height);
// };

// export const openPIP = async (videosArray) =>
// {
// 	// // if (isInPIP()) return;

// 	// if (supportsOldSafariPIP())
// 	// {
// 	// 	// await video?.webkitSetPresentationMode('picture-in-picture');
// 	// }
// 	// if (supportsModernPIP())
// 	// {
// 	// await video?.requestPictureInPicture();
// 	const canvas = document.createElement('canvas');
// 	const canvasHeight = 400;
// 	const canvacWidth = 1280;

// 	canvas.height = canvasHeight * 2;
// 	canvas.width = canvacWidth;
// 	canvas.style.borderColor = 'red';
// 	const ctx = canvas.getContext('2d');
// 	const video = document.createElement('video');

// 	ctx.fillStyle = 'black';
// 	ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

// 	// ctx.shadowColor = 'blue';
// 	// ctx.shadowBlur = 15;
// 	video.srcObject = canvas.captureStream();
// 	ctx.translate(canvas.width, 0);
// 	ctx.scale(-1, 1);

// 	anim();
// 	await video.play();

// 	if (!isInPIP())
// 	{
// 		video.requestPictureInPicture()
// 			.then((res) =>
// 			{
// 			// setpipStatus(true)
// 			})
// 			.catch((err) =>
// 			{
// 			});

// 	}

// 	function anim()
// 	{
// 		if (videosArray && videosArray.length > 0 && videosArray.length === 1)
// 		{
// 			styleDrawEle(
// 				ctx, videosArray[0], 0, 0, video.videoWidth, video.videoHeight);
// 		}
// 		else if (videosArray && videosArray.length > 0 && videosArray.length === 2)
// 		{
// 			styleDrawEle(
// 				ctx,
// 				videosArray[0],
// 				40,
// 				canvas.height / 4,
// 				(canvas.width / 2) - 80,
// 				canvas.height / 2);
// 			styleDrawEle(
// 				ctx,
// 				videosArray[1],
// 				(canvas.width / 2) + 40,
// 				canvas.height / 4,
// 				(canvas.width / 2) - 80,
// 				canvas.height / 2);
// 		}
// 		else if (videosArray && videosArray.length > 0 && videosArray.length === 3)
// 		{
// 			styleDrawEle(
// 				ctx,
// 				videosArray[0], 40, 60, (canvas.width / 2) - 80, canvas.height / 2 - 80);
// 			styleDrawEle(ctx, videosArray[1],
// 				(canvas.width / 2) + 40,
// 				60,
// 				(canvas.width / 2) - 80,
// 				canvas.height / 2 - 80);
// 			styleDrawEle(ctx, videosArray[2],
// 				canvas.width / 4 + 40,
// 				canvas.height / 2 + 30,
// 				(canvas.width / 2) - 80,
// 				canvas.height / 2 - 80);
// 		}
// 		else
// 		{
// 			styleDrawEle(
// 				ctx,
// 				videosArray[0], 40, 60, (canvas.width / 2) - 70, canvas.height / 2 - 80);
// 			styleDrawEle(ctx, videosArray[1],
// 				(canvas.width / 2) + 30,
// 				60,
// 				(canvas.width / 2) - 70,
// 				canvas.height / 2 - 80);
// 			styleDrawEle(ctx, videosArray[2],
// 				40,
// 				canvas.height / 2 + 30,
// 				(canvas.width / 2) - 70,
// 				canvas.height / 2 - 80);
// 			styleDrawEle(ctx, videosArray[3],
// 				(canvas.width / 2) + 30,
// 				canvas.height / 2 + 30,
// 				(canvas.width / 2) - 70,
// 				canvas.height / 2 - 80);
// 		}
// 		window.requestAnimationFrame(anim);
// 	}
// };

export const closePIP = async (video) =>
{
	if (!isInPIP()) return;

	if (supportsOldSafariPIP())
	{
		try
		{

			await video?.webkitSetPresentationMode('inline');
		}
		catch (err)
		{
			console.log('eeror in exit pip', err);

		}
	}

	if (supportsModernPIP())
	{
		try
		{

			await document?.exitPictureInPicture();
		}
		catch (err)
		{
			console.log('eeror in exit pip', err);

		}

	}
};
